interface Properties {
  width?: number;
  height?: number;
  color?: string;
  /** Degrees to rotate — the design reuses this one glyph for both the
      vertical and horizontal layout buttons via rotation. */
  rotate?: number;
}

/** Figma 75644:18534 / 75644:18538 "chart-tree" — a 3-level tree/hierarchy glyph. */
const FigmaTreeLayoutIcon = ({
  width = 20,
  height = 20,
  color = '#121826',
  rotate = 0,
}: Properties) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    style={{ transform: rotate ? `rotate(${rotate}deg)` : undefined }}
  >
    <path
      d='M17.5 14.2092V12.0833C17.5 10.935 16.5658 10 15.4167 10H10.4167V7.4575C12.2867 7.2475 13.75 5.675 13.75 3.75C13.75 1.6825 12.0675 0 10 0C7.9325 0 6.25 1.6825 6.25 3.75C6.25 5.675 7.71333 7.2475 9.58333 7.4575V10H4.58333C3.43417 10 2.5 10.935 2.5 12.0833V14.2092C1.09 14.4133 0 15.6183 0 17.0833C0 18.6917 1.30833 20 2.91667 20C4.525 20 5.83333 18.6917 5.83333 17.0833C5.83333 15.6183 4.74333 14.4133 3.33333 14.2092V12.0833C3.33333 11.3942 3.89417 10.8333 4.58333 10.8333H9.58333V14.2092C8.17333 14.4133 7.08333 15.6183 7.08333 17.0833C7.08333 18.6917 8.39167 20 10 20C11.6083 20 12.9167 18.6917 12.9167 17.0833C12.9167 15.6183 11.8267 14.4133 10.4167 14.2092V10.8333H15.4167C16.1058 10.8333 16.6667 11.3942 16.6667 12.0833V14.2092C15.2567 14.4133 14.1667 15.6183 14.1667 17.0833C14.1667 18.6917 15.475 20 17.0833 20C18.6917 20 20 18.6917 20 17.0833C20 15.6183 18.91 14.4133 17.5 14.2092ZM7.08333 3.75C7.08333 2.14167 8.39167 0.833333 10 0.833333C11.6083 0.833333 12.9167 2.14167 12.9167 3.75C12.9167 5.35833 11.6083 6.66667 10 6.66667C8.39167 6.66667 7.08333 5.35833 7.08333 3.75ZM5 17.0833C5 18.2317 4.06583 19.1667 2.91667 19.1667C1.7675 19.1667 0.833333 18.2317 0.833333 17.0833C0.833333 15.935 1.7675 15 2.91667 15C4.06583 15 5 15.935 5 17.0833ZM12.0833 17.0833C12.0833 18.2317 11.1492 19.1667 10 19.1667C8.85083 19.1667 7.91667 18.2317 7.91667 17.0833C7.91667 15.935 8.85083 15 10 15C11.1492 15 12.0833 15.935 12.0833 17.0833ZM17.0833 19.1667C15.9342 19.1667 15 18.2317 15 17.0833C15 15.935 15.9342 15 17.0833 15C18.2325 15 19.1667 15.935 19.1667 17.0833C19.1667 18.2317 18.2325 19.1667 17.0833 19.1667Z'
      fill={color}
    />
  </svg>
);

export default FigmaTreeLayoutIcon;
